import React from "react";

export default function NoMatch(){
    return(
        <div>404!</div>
    )
}